import styles from "./resources/scss/main.scss";
import "owl.carousel/dist/assets/owl.carousel.css";
require("./resources/js/jquery-global");
require("bootstrap");
require("readmore-js");
require("/resources/js/app.js");
require("owl.carousel");
require("jquery.cookie");
// require("./resources/js/masonry");
require("@fancyapps/fancybox");
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// ..
AOS.init();
